import { render, staticRenderFns } from "./PaoStructure.vue?vue&type=template&id=7b28b75a&scoped=true"
import script from "./PaoStructure.vue?vue&type=script&lang=js"
export * from "./PaoStructure.vue?vue&type=script&lang=js"
import style0 from "./PaoStructure.vue?vue&type=style&index=0&id=7b28b75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28b75a",
  null
  
)

export default component.exports